// extracted by mini-css-extract-plugin
module.exports = {"card":"PrivacyPolicy_card__nN4Eg"};